<template>
    <v-card class="p-4 w-100 mr-4 delegation">
        <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
            <div class="custom-icon-wrapper">
                <v-icon @click="backToDashboardsPage()">custom-icon left-arrow-icon</v-icon>
            </div>
            <v-toolbar-title class="size-16 dark-text p-4 label">{{ $t("res_TabsName_Dashboard") }}</v-toolbar-title>
        </v-toolbar>
        <hr>
            <div class="container">
                <div class="cts-form align-items-start">
                    <div class="cts-field">
                        <v-label class="label_required mb-1 ">{{ $t("res_Label_SelectStructure") }}<span> *</span></v-label>
                            <StructureUserSelector
                                :showInternalUsers="false"
                                :showExternalUsers="false"
                                :showInternalStructures="true"
                                :showExternalStructures="false"
                                :excludeSelf="false"
                                :isMultiple="false"
                                :selectedStructureUser="structure"
                                @structureUserSelectChanged="setStructure"
                                :loadOnlyInScopeInternalStrucutres="true"
                                :addressBook_header="$t('res_Label_SelectStructure')">
                            </StructureUserSelector>
                    </div>
                    <div class="cts-field">
                        <v-label class="label_required mb-1 ">{{ $t("res_Label_FromDate") }}<span> *</span></v-label>
                        <v-menu content-class="p-0" v-model="from_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template   v-slot:activator="{ on, attrs }">
                                <v-text-field   class="shrink dtField " :label="$t('res_Label_SelectDate')" :value="utils.dateFormat(fromDate)" solo v-on="on" append-icon="mdi-calendar" 
                                    :tabindex="-1" v-bind="attrs">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker :locale="lang" v-model="fromDate" @input="from_date_menu = false"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="cts-field">
                        <v-label class="label_required mb-1">{{ $t("res_Label_ToDate") }}<span> *</span></v-label>
                        <v-menu  content-class="p-0" v-model="to_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field id="date-white-bg" class="shrink dtField " :label="$t('res_Label_SelectDate')" :value="utils.dateFormat(toDate)" solo v-on="on" 
                                    append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker :locale="lang" v-model="toDate" @input="to_date_menu = false"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="cts-field">
                        <v-label>{{ $t('res_Label_getAllHierarchy') }}</v-label>
                        <v-checkbox class="m-0" v-model="viewAllHierarchy"></v-checkbox>
                    </div>
                </div>
                <div class="d-flex justify-content-end gap-2">
                    <v-btn @click="clearFilter()" color="light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                    <v-btn dense @click="GetData" class=" primary">{{ $t("res_ButtonText_ApplyFilter") }}</v-btn>
                </div>
                <hr />
            <!-- 4 boxes with icons  -->
                <div class="cts-form">
                    <div class="cts-field">
                        <v-card class="bg-white d-flex justify-content-between align-items-center p-4 rounded-4" >
                            <v-icon class="blue-icon"> mdi-email-open-outline </v-icon>
                            <span class="size-18">{{ $t("res_Label_OpenCorrespondences") }}</span>
                            <span class="size-18 float-right p-0">{{ categoriesCounts.Correspondences }}</span>
                        </v-card>
                    </div>
                    <div class="cts-field">
                        <v-card class="bg-white d-flex justify-content-between align-items-center p-4 rounded-4">
                            <v-icon class="blue-icon">mdi-aspect-ratio </v-icon>
                            <span class="size-18">{{ $t("res_Label_OpenTransfers") }}</span>
                            <span class="size-18 float-right p-0">{{ categoriesCounts.OpenTransfers }}</span>
                        </v-card>
                    </div>
                    <div class="cts-field">
                        <v-card class="bg-white d-flex justify-content-between align-items-center p-4 rounded-4">
                            <v-icon class="blue-icon"> mdi-pencil-outline </v-icon>
                            <span class="size-18">{{ $t("res_Label_NeedSignature") }}</span>
                            <span class="size-18 float-right p-0">{{ categoriesCounts.NeedSignature }}</span>
                        </v-card>
                    </div>
                    <div class="cts-field">
                        <v-card class="bg-white d-flex justify-content-between align-items-center p-4 rounded-4">
                            <v-icon class="blue-icon"> mdi-history </v-icon>
                            <span class="size-18">{{ $t("res_Label_DelayedTransfers") }}</span>
                            <span class="size-18 float-right p-0">{{ categoriesCounts.DelayedTransfers }}</span>
                        </v-card>
                    </div>
                </div>

                <div class="cts-form mt-3">
                    <div class="cts-field cts-field-full mb-2">
                        <v-card class="bg-white rounded-top-corners">
                            <div class="d-flex justify-content-end align-items-start flex-column mb-1">
                                <span class="dashboarCardTitle mt-2">{{ $t("res_Label_TotalReceiveVsClosed") }}</span>
                                <span style="font-size: 0.8rem; padding-left: 15px; padding-right: 15px; display: block">Per Structure</span>
                            </div>
                            <apexchart type="bar" height="130%" :options="BarChartOptions" :series="chartSeries" style="padding-bottom: 15px;" />
                        </v-card>
                    </div>
                </div>

                <div class="cts-form">
                    <div class="cts-field">
                        <v-card class="bg-white flex-1 rounded-top-corners pt-5">
                        <div class="mb-2"> 
                            <span class="dashboarCardTitle m-0 ml-2">{{ $t("res_Label_Received") }}</span>
                                <apexchart height="300px" type="donut" :options="ReceivedDonutChartOptions" :series="ReceivedDonutChartSeries" />
                            </div>
                            <div class="d-flex flex-wrap m-0 p-2" style="background: rgb(0 0 0 / 3%);">
                                <div class="flex-fill text-center align-self-start">
                                    <span class="action-label-new">Previous Year</span>
                                    <div class="d-flex align-items-center justify-content-center gap-1">
                                        <p class="main-text-large m-0 ">---</p>
                                        <span class="text-increase d-inline-flex gap-0"><v-icon>mdi-arrow-up</v-icon>--%</span>
                                    </div>
                                </div>
                                <div class="flex-fill align-self-center text-center">
                                    <span class="action-label-new ">Year 2021</span>
                                    <div class="d-flex align-items-center justify-content-center gap-1">
                                        <p class="main-text-large m-0 ">---</p>
                                        <span class="text-decrease d-inline-flex gap-0"><v-icon>mdi-arrow-down</v-icon>--%</span>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <div class="cts-field">
                        <v-card class="bg-white flex-1 rounded-top-corners pt-5">
                            <div class="mb-2"> 
                                <span class="dashboarCardTitle m-0 ml-2">{{ $t("res_Label_Closed") }}</span>
                                <apexchart  type="donut" height="300px" :options="ClosedDonutChartOptions" :series="ClosedDonutChartSeries" />
                            </div>
                            <div class="d-flex flex-wrap m-0 p-2" style="background: rgb(0 0 0 / 3%);">
                                <div class="flex-fill text-center align-self-start">
                                    <span class="action-label-new">Previous Year</span>
                                    <div class="d-flex align-items-center justify-content-center gap-1">
                                        <p class="main-text-large m-0 ">--</p>
                                        <span class="text-increase d-inline-flex gap-0"><v-icon>mdi-arrow-up</v-icon>0%</span>
                                    </div>
                                </div>
                                <div class="flex-fill align-self-center text-center">
                                    <span class="action-label-new">Year 2021</span>
                                    <div class="d-flex align-items-center justify-content-center gap-1">
                                        <p class="main-text-large m-0 ">---</p>
                                        <span class="text-stable d-inline-flex gap-0"><v-icon>mdi-minus</v-icon>0%</span>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </div>      

                    <div class="cts-field">
                        <v-card class="bg-white flex-1 rounded-top-corners pt-5">
                            <div class="mb-2"> 
                                <span class="dashboarCardTitle m-0 ml-2" >{{ $t("res_Label_Overdue") }}</span>
                                <apexchart type="donut" height="300px" :options="OverdueDonutChartOptions" :series="OverdueDonutChartSeries" />
                            </div>
                            <div class="d-flex flex-wrap m-0 p-2" style="background: rgb(0 0 0 / 3%);">
                                <div class="flex-fill text-center align-self-start">
                                    <span class="action-label-new">Previous Year</span>
                                    <div class="d-flex align-items-center justify-content-center gap-1">
                                        <p class="main-text-large m-0">---</p>
                                        <span class="text-increase d-inline-flex gap-0"><v-icon>mdi-arrow-up</v-icon>--%</span>
                                    </div>
                                </div>
                                <div class="flex-fill align-self-center text-center">
                                    <span class="action-label-new ">Year 2021</span>
                                    <div class="d-flex align-items-center justify-content-center gap-1">
                                        <p class="main-text-large m-0">---</p>
                                        <span class="text-decrease d-inline-flex gap-0"><v-icon>mdi-arrow-down</v-icon>--%</span>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
    </v-card>
</template>

<script>
    import * as utils from "@/assets/js/common.js";
    import StructureUserSelector from "@/components/StructureUserSelector.vue";
    import VueApexCharts from "vue-apexcharts";
    import constants from "@/assets/js/constants.js";
    import axios from "axios";
    import router from '../router/index.js';
    export default {
        name: "Dashboard",
        components: { StructureUserSelector, VueApexCharts },
        data() {
            return {
                categoriesCounts: {
                    Correspondences: 0,
                    OpenTransfers: 0,
                    NeedSignature: 0,
                    DelayedTransfers: 0,
                },
                viewAllHierarchy: false,
                fromDate: "",
                toDate: "",
                from_date_menu: false,
                to_date_menu: false,
                structure: null,
                getAllHierarchy: false,
                utils: utils,
                constants: constants,
                chartSeries: [],
                BarChartOptions: {
                    chart: { type: "bar" },
                    xaxis: { categories: [] },
                    series: [],
                    plotOptions: {
                        bar: { horizontal: false, columnWidth: "55%", endingShape: "rounded" },
                    },
                    dataLabels: { enabled: false },
                    stroke: { show: true, width: 0, colors: ["transparent"] },
                    yaxis: {
                        title: { text: "" },
                    },
                    fill: { opacity: 1 },
                    tooltip: {
                        y: {
                            formatter: function (val) { return val; },
                        },
                    },
                },
                ReceivedDonutChartOptions: {},
                DonutplotOptions: {
                    pie: {
                        donut: {
                            size: "70%",
                            labels: {
                                show: true,
                                name: { show: true },
                                value: {
                                    show: true,
                                    fontWeight: "bold",
                                    formatter: function (val) { return val; },
                                },
                                total: { show: true, label: "Total", fontSize: "11px", color: "#373d3f" },
                            }
                        }
                    }
                },
                ReceivedDonutChartSeries: [],
                ClosedDonutChartOptions: { chart: { type: "donut" }, labels: [] },
                Total2: 0,
                ClosedDonutChartSeries: [],
                OverdueDonutChartOptions: { chart: { type: "donut" }, labels: [] },
                Total3: 0,
                OverdueDonutChartSeries: [],
                lang: localStorage.getItem('lang')
            };
        },
        mounted() 
        {
            this.GetData();
        },
        methods: 
        {
            setStructure(item) 
            {
                this.structure = item;
            },
            GetData: function () 
            {
                if(!this.validateDate()){
                    return;
                }
                axios.get(constants.baseApiUrl + "Dashboard/GetDashboardCounts?structureId=" + (this.structure?.id ?? -1) 
                        + "&fromDate=" + this.fromDate + "&toDate=" + this.toDate +"&viewAllHierarchy=" + this.viewAllHierarchy, { headers: constants.headers })
                    .then((res) => 
                    {
                        if (res != null && res != undefined) 
                        {
                            this.prepareChartData(res.data);
                        }
                    })
                    .catch((err) => console.warn(err));
            },
            prepareChartData(res) 
            {
                this.categoriesCounts = {
                    Correspondences: res.countByStatus && res.countByStatus.openCorrespondences > 0 ? res.countByStatus.openCorrespondences : 0,
                    OpenTransfers: res.countByStatus && res.countByStatus.openTransfers > 0 ? res.countByStatus.openTransfers : 0,
                    NeedSignature: res.countByStatus && res.countByStatus.needSignature > 0 ? res.countByStatus.needSignature : 0,
                    DelayedTransfers: res.countByStatus && res.countByStatus.delayedTransfers > 0 ? res.countByStatus.delayedTransfers : 0,
                };

                this.BarChartOptions = {
                    colors: ["RGB(117,59,189)", "RGB(214,196,235)"],
                    xaxis: {
                        categories: Object.values(res.dashboardReceivedClosedCounts).map((d) => d.companyName),
                    },
                };

                this.chartSeries = [
                    {
                        name:  window.translate("res_Label_TotalReceived"),
                        data: Object.values(res.dashboardReceivedClosedCounts).map((d) => d.totalReceived),
                    },
                    {
                        name: window.translate("res_Label_Closed"),
                        data: Object.values(res.dashboardReceivedClosedCounts).map((d) => d.closed),
                    },
                ];

                const countsByStatusData = res.countsByStatusCategories;
                const DonutLabels = countsByStatusData.map((d) => d.category);
                this.ReceivedDonutChartOptions = {
                    chart: { type: "donut" },
                    labels: DonutLabels,
                    colors: ["#41729F", "#5885AF", "#274472"],
                    total: countsByStatusData.reduce((sum, d) => sum + d.received, 0), // Calculate the total received
                    plotOptions: this.DonutplotOptions,
                    dataLabels: { enabled: false },
                    legend: { position: "bottom" }
                };

                this.ReceivedDonutChartSeries = Object.values(countsByStatusData).map((d) => d.received);
                this.ClosedDonutChartOptions = {
                    chart: { type: "donut" },
                    labels: DonutLabels,
                    colors: ["#116530", "#21B6A8", "#A3EBB1"],
                    total: countsByStatusData.reduce((sum, d) => sum + d.closed, 0), // Calculate the total received
                    plotOptions: this.DonutplotOptions,
                    dataLabels: { enabled: false },
                    legend: { position: "bottom" }
                };

                this.ClosedDonutChartSeries = Object.values(countsByStatusData).map((d) => d.closed);

                this.OverdueDonutChartOptions = {
                    chart: { type: "donut" },
                    labels: DonutLabels,
                    colors: ["#F0CCB0", "#B97D60", "#F0A160"],
                    total: countsByStatusData.reduce((sum, d) => sum + d.overdue, 0),
                    plotOptions: this.DonutplotOptions,
                    dataLabels: { enabled: false },
                    legend: { position: "bottom" }
                };

                this.OverdueDonutChartSeries = Object.values(countsByStatusData).map((d) => d.overdue);
            },
            onChangeDateRange(event, FromOrTo) 
            {
                if (FromOrTo == 1) 
                {
                    if (new Date(this.fromDate) > new Date(this.toDate)) 
                    {
                        window.showAlert("res_Msgs_FromDateCompare", "warning");
                        this.fromDate = window.newDate().toISOString().substr(0, 10);
                    } 
                    else 
                    {
                        this.fromDate = event;
                    }
                } 
                else 
                {
                    if (new Date(this.toDate) < new Date(this.fromDate)) 
                    {
                        window.showAlert("res_Msgs_ToDateCompare", "warning");
                        this.toDate = window.newDate().toISOString().substr(0, 10);
                    } 
                    else 
                    {
                        this.toDate = event;
                    }
                }
            },
            validateDate(){
                var now = new Date().toISOString().slice(0, 10);
                
                if(this.fromDate && this.toDate){
                    if(this.fromDate > this.toDate){
                        window.showAlert("res_Msgs_FromDateCompare", "warning");
                        return false;
                    }
                    return true;
                }else {
                    window.showAlert("res_Msgs_EnterDates", "warning");
                    return false;
                }
            },
            clearFilter(){
                this.structure = null;
                this.fromDate = "";
                this.toDate = "";
                this.viewAllHierarchy = false;
            },
            backToDashboardsPage() {
                router.push({ name: 'dashboards' })
        },
        },
    };
</script>

<style>
    .dashboarCardTitle { font-weight: 1000; margin-top: 15px; padding: 15px; font-size: 1.2rem; }
</style>